import { Divider, Typography } from "@mui/material";
import i18nPackage from "../../i18n/i18n";

export default function CoreDividerWithText({
	children = i18nPackage.t("coreComponents.divider.OR"),
	className,
}: {
	children?: string;
	className?: string;
}) {
	return (
		<Divider role="separator" aria-label={children}>
			<Typography component="span" className={className}>
				{children}
			</Typography>
		</Divider>
	);
}
